import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RegistriesService} from "../../../service";
import {Utils} from "@amlCore/utils";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-registry-bounce-register-form',
  templateUrl: './bounceRegister.component.html'
})
export class BounceRegisterComponent implements OnInit {
  @Input() id = null;
  @Input() hideGoBackBtn = false;
  @Input() isModal = false;
  @Output() startLoading: any = new EventEmitter<boolean>();
  @Output() finishLoading: any = new EventEmitter<boolean>();

  item11: any;
  item12: any;
  item2: any;
  subjectId = null;

  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              private _activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.id) {
      this.startLoading.emit(true);
      this.startLoading.complete();
      this.loadSubject(this.id);
    } else {
      this.route.params.subscribe(params => {
        Utils.scrollTopSmooth();
        this.id = params.id;
        this.loadSubject(this.id);
      });
    }
  }

  loadSubject(id) {
    this.regSrv.getBounceRegisterById(id).subscribe(data => {
      if (data.razdel11?.length > 0) {
        this.item11 = data.razdel11[0];
      } else if (data.razdel12?.length > 0) {
        this.item12 = data.razdel12[0];
      } else if (data.razdel2?.length > 0) {
        this.item2 = data.razdel2[0];
      }
      this.finishLoading.emit(false);
      this.finishLoading.complete();
    });
  }

  getTypeDescription(type: any) {
    switch (type) {
      case "1": {
        return 'Юридическое лицо';
      }
      case "2": {
        return 'Физическое лицо';
      }
      case "3": {
        return 'Индивидуальный предприниматель';
      }
      case "4": {
        return 'Физическое лицо, занимающееся частной практикой';
      }
      case "5": {
        return 'Иностранная структура без образования юридического лица';
      }
      default: {
        return '';
      }
    }
  }

  getDocumentDescription(type: any) {
    switch (type) {
      case '21': {
        return 'Паспорт гражданина Российской Федерации (для гражданина Российской Федерации, достигшего 14 лет)';
      }
      case '22': {
        return 'Основной документ, удостоверяющий личность гражданина Российской Федерации за пределами территории Российской Федерации';
      }
      case '23': {
        return 'Удостоверение личности моряка/паспорт моряка';
      }
      case '24': {
        return 'Удостоверение личности военнослужащего (для офицеров, прапорщиков и мичманов)';
      }
      case '25': {
        return 'Военный билет военнослужащего (для сержантов, старшин, солдат и матросов,' +
          ' а также курсантов военных образовательных учреждений профессионального образования)';
      }
      case '26': {
        return 'Временное удостоверение личности гражданина Российской Федерации, выдаваемое органом внутренних дел до оформления паспорта';
      }
      case '27': {
        return 'Свидетельство органов ЗАГС, органа исполнительной власти или органа местного самоуправления' +
          ' о рождении гражданина (для гражданина Российской Федерации, не достигшего 14 лет)';
      }
      case '28': {
        return 'Иные документы, признаваемые в соответствии с законодательством Российской Федерации документами, удостоверяющими личность';
      }
      case '31': {
        return 'Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый' +
          ' в соответствии с международным договором Российской Федерации в качестве документа,' +
          ' удостоверяющего личность иностранного гражданина';
      }
      case '32': {
        return 'Документ, выданный иностранным государством и признаваемый в соответствии с международным договором' +
          ' Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина';
      }
      case '33': {
        return 'Вид на жительство (для лиц без гражданства, если они постоянно проживают на территории Российской Федерации)';
      }
      case '34': {
        return 'Разрешение на временное проживание (для лиц без гражданства)';
      }
      case '35': {
        return 'Иные документы, предусмотренные федеральными законами или признаваемые в соответствии с международным' +
          ' договором Российской Федерации в качестве документов, удостоверяющих личность лица без гражданства';
      }
      case '36': {
        return 'Свидетельство о рассмотрении ходатайства о признании лица беженцем, выданное дипломатическим или' +
          ' консульским учреждением Российской Федерации, или постом иммиграционного контроля, или территориальным' +
          ' органом федеральной исполнительной власти по миграционной службе';
      }
      case '37': {
        return 'Удостоверение беженца';
      }
      case '38': {
        return 'Удостоверение вынужденного переселенца';
      }
      case '39': {
        return 'Миграционная карта';
      }
      case '40': {
        return 'Иной документ, подтверждающий в соответствии с законодательством' +
          ' Российской Федерации право иностранного гражданина на пребывание (проживание) в Российской Федерации';
      }
      case '41': {
        return 'Свидетельство о предоставлении временного убежища на территории Российской Федерации';
      }
      case '42': {
        return 'Справка о рассмотрении заявления о предоставлении временного убежища';
      }
      default: {
        return '';
      }
    }
  }

  getTypeEntry(type: any) {
    switch (type) {
      case "1":
      case "2":{
        return 'при первичном направлении информации';
      }
      case "3": {
        return 'при направлении в уполномоченный орган (Росфинмониторинг) корректировок ранее направленной информации (скорректированной информации)';
      }
      case "4": {
        return 'при информировании уполномоченного органа (Росфинмониторинга) об удалении ранее направленной информации, в случае ошибочно направленной информации';
      }
      case "5": {
        return 'при информировании уполномоченного органа (Росфинмониторинга):<br>' +
          '- об устранении указанного в абзаце втором пункта 5<sup>2</sup> статьи 7 Федерального закона № 115-ФЗ основания, в соответствии с которым кредитной организацией ранее было принято решение об отказе от заключения договора банковского счета (вклада), сведения о котором были представлены в уполномоченный орган (Росфинмониторинг);<br>' +
          '- об отсутствии оснований для расторжения договора банковского счета (вклада) (сведения о котором были представлены в уполномоченный орган (Росфинмониторинг)), если указанный договор банковского счета (вклада) был расторгнут кредитной организацией в связи с решением об отказе от проведения операции, в отношении которого впоследствии были устранены основания принятия такого решения;';
      }
      case "6": {
        return 'при информировании уполномоченного органа (Росфинмониторинга):<br>' +
          '- о получении кредитной организацией решения межведомственной комиссии об отсутствии оснований, в соответствии с которыми кредитной организацией ранее было принято решение об отказе от заключения договора банковского счета (вклада), сведения о котором были представлены в уполномоченный орган (Росфинмониторинг);<br>' +
          '- об отсутствии оснований для расторжения договора банковского счета (вклада) (сведения о котором были представлены в уполномоченный орган (Росфинмониторинг)), если указанный договор банковского счета (вклада) был расторгнут кредитной организацией в связи с решением об отказе от проведения операции, в отношении которого впоследствии было получено решение межведомственной комиссии об отсутствии таких оснований;';
      }
      case "7": {
        return 'при информировании уполномоченного органа (Росфинмониторинга):<br>' +
          '- об отмене судом ранее принятого кредитной организацией решения об отказе от заключения договора банковского счета (вклада), предусмотренного абзацем вторым пункта 5<sup>2</sup> статьи 7 Федерального закона № 115-ФЗ, сведения о котором были представлены в уполномоченный орган (Росфинмониторинг);<br>' +
          '- об отмене судом ранее принятого кредитной организацией решения о расторжении договора банковского счета (вклада), предусмотренного абзацем третьим пункта 5<sup>2</sup> статьи 7 Федерального закона № 115-ФЗ, сведения о котором были представлены в уполномоченный орган (Росфинмониторинг);';
      }
      case "8": {
        return 'при информировании уполномоченного органа (Росфинмониторинга) об отсутствии оснований для расторжения договора банковского счета (вклада) (сведения о котором были представлены в уполномоченный орган (Росфинмониторинг)) в связи с отменой судом ранее принятого кредитной организацией решения об отказе от проведения операции, в связи с которым договор банковского счета (вклада) был расторгнут';
      }
      default: {
        return type;
      }
    }
  }

  getCodeEntry(type: any) {
    switch (type) {
      case "03": {
        return 'отказ от заключения договора банковского счета (вклада)';
      }
      case "09": {
        return 'расторжение договора банковского счета (вклада)';
      }
      default: {
        return type;
      }
    }
  }

  /**
   * Признак участника
   * 1 - Резидент
   * 0 – Не резидент
   */
  getPriznakUch(priznak: any) {
    switch (priznak) {
      case "1": {
        return 'Резидент';
      }
      case "0": {
        return 'Нерезидент';
      }
      default: {
        return priznak;
      }
    }
  }

  /**
   * Тип физического лица, занимающегося частной практикой
   */
  getTypeFlChastnPract(type: any) {
    switch (type) {
      case "1": {
        return 'нотариус';
      }
      case "2": {
        return 'адвокат';
      }
      default: {
        return type;
      }
    }
  }

  /**
   * ПризнакИнф
   */
  getPriznakInf(type: any) {
    switch (type) {
      case "0": {
        return 'информация, полученная от Банка России в соответствии с пунктом 13.3 статьи 7 Федерального закона N 115-ФЗ,' +
          ' не использовалась при принятии кредитной организацией (филиалом кредитной организации), НФО (филиалом НФО)' +
          ' решения об отказе в выполнении распоряжения клиента о совершении операции;';
      }
      case "1": {
        return 'информация, полученная от Банка России в соответствии с пунктом 13.3 статьи 7 Федерального закона N 115-ФЗ,' +
          ' была использована при принятии кредитной организацией (филиалом кредитной организации), НФО (филиалом НФО)' +
          ' решения об отказе в выполнении распоряжения клиента о совершении операции.';
      }
      default: {
        return type;
      }
    }
  }


  /**
   * Код отказа
   */
  getKodOtkaza(type: any) {
    switch (type) {
      case "03": {
        return '(03) в случае отказа от заключения договора банковского счета (вклада) в соответствии с правилами внутреннего контроля' +
          ' кредитной организации в случае наличия подозрений о том, что целью заключения' +
          ' такого договора является совершение операций в целях легализации (отмывания) ' +
          'доходов, полученных преступным путем, или финансирования терроризма.';
      }

      case "07": {
        return '(07) для совершения операции не представлены документы, необходимые' +
          ' для фиксирования информации в соответствии с положениями Федерального закона N 115-ФЗ.';
      }
      case "08": {
        return '(08) в результате реализации правил внутреннего контроля в целях противодействия легализации (отмыванию) доходов, ' +
          'полученных преступным путем, и финансированию терроризма у работников кредитной организации (филиала кредитной организации),' +
          ' НФО (филиала НФО) возникли подозрения, что операция совершается в целях легализации ' +
          '(отмывания) доходов, полученных преступным путем.';
      }
      case "09": {
        return '(09) в случае расторжения договора банковского счета (вклада) с клиентом в случае принятия в течение календарного' +
          ' года двух и более решений об отказе в выполнении распоряжения клиента о совершении операции.';
      }
      case "80": {
        return '(80) в результате реализации правил внутреннего контроля в целях противодействия легализации' +
          ' (отмыванию) доходов, полученных преступным путем, и финансированию терроризма у работников' +
          ' кредитной организации (филиала кредитной организации), НФО (филиала НФО) возникли подозрения, ' +
          'что операция совершается в целях финансирования терроризма.';
      }
      default: {
        return type;
      }
    }
  }

  /**
   * Код денежных средств
   */
  getDenezhSr(type: any) {
    switch (type) {
      case "1": {
        return 'наличные денежные средства';
      }
      case "2": {
        return 'безналичные денежные средства;';
      }
      case "3": {
        return 'для электронные денежные средства;';
      }
      default: {
        return type;
      }
    }
  }

  /**
   * ПризнакОргФормаИНБОЮЛ
   */
  getOrgFormINBOUL(type: any) {
    switch (type) {
      case "0": {
        return 'траст или иная иностранная структура без образования юридического лица с аналогичной структурой или функцией';
      }
      case "1": {
        return 'фонд';
      }
      case "2": {
        return 'партнерство';
      }
      case "3": {
        return 'товарищество';
      }
      case "4": {
        return 'иная форма осуществления коллективных инвестиций и (или) доверительного управления';
      }
      default: {
        return type;
      }
    }
  }

  /**
   * Статус участника
   */
  getStatusUch(type: any) {
    switch (type) {
      case "1": {
        return 'плательщик';
      }
      case "2": {
        return 'получатель';
      }
      case "3": {
        return 'представитель плательщика';
      }
      case "4": {
        return 'представитель получателя';
      }
      case "5": {
        return 'лицо, действующее от имени и по поручению плательщика';
      }
      case "6": {
        return 'выгодоприобретатель';
      }
      case "7": {
        return 'лицо, действующее от имени и по поручению получателя';
      }
      default: {
        return type;
      }
    }
  }

  getFullName(fio: any) {
    return (fio.fam ? fio.fam : '')
      + ' ' + (fio.imia ? fio.imia : '')
      + ' ' + (fio.otch ? fio.otch : '');
  }

  getUchastnikTitle(uch) {
    if (uch.svedIuL && uch.svedIuL.naimIuL) {
      return uch.svedIuL.naimIuL;
    } else if (uch.svedFLIP && uch.svedFLIP.fioflip) {
      return this.getFullName(uch.svedFLIP.fioflip);
    } else if (uch.svedINBOIuL && uch.svedINBOIuL.naimINBOIuL) {
      return uch.svedINBOIuL.naimINBOIuL;
    } else {
      return 'Участник';
    }
  }
  getNameUchrediteli(nameUchr) {
    if (nameUchr.fizLitso) {
      return `${nameUchr.fizLitso.fam} ${nameUchr.fizLitso.imia} ${nameUchr.fizLitso.otch}`;
    } else {
      return nameUchr.iurLitso;
    }
  }

  closeModal() {
    this._activeModal.dismiss(false);
  }
}
